export default {
  'have-procedure-se': 'Realizar acciones del folio ante S.E.',
  'assign-products': 'Asignar inspector',
  'edit-products': 'Editar',
  'delete-invoice': 'Desechar folio'
};
